import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DocumentPage } from '../../shared/models/document-page';
import { Observable } from 'rxjs';
import { FeatureFlag } from 'src/app/shared/models/enums/feature-flag';
import { DocumentTypeRequirementTextDto } from '../api/models/document-type-requirement-text-dto.model';

@Component({
    selector: 'nova-pdf-viewer-dialog',
    templateUrl: './pdf-viewer-dialog.component.html',
    styleUrls: ['./pdf-viewer-dialog.component.scss']
})
export class PdfViewerDialog implements OnInit {
    textRequirements: DocumentTypeRequirementTextDto[] = [];
    pages: DocumentPage[] = [];
    featureFlag = FeatureFlag;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            pages?: DocumentPage[];
            pageNumber?: number;
            textRequirements?: DocumentTypeRequirementTextDto[];
            revision?: unknown;
            document$: Observable<any>;
        }
    ) {}

    ngOnInit(): void {
        this.textRequirements = this.data.textRequirements || [];
        this.pages = this.data.pages || [];
    }
}
